import { Wrapper } from '@american-autonomy/ag-ui';

import type { CardContent, FunctionComponent } from './types';

import styles from './styles.module.scss';

type TitleRowProps = {
    content: CardContent;
};

const TitleRow: FunctionComponent<TitleRowProps> = ({ content }) => {
    if (content.airportCode === null) {
        return <Wrapper className={styles.title}>{content.title}</Wrapper>;
    }

    return (
        <Wrapper className={styles.title}>
            {`${content.title} `}

            <span className={styles.airportCode}>{`(${content.airportCode})`}</span>
        </Wrapper>
    );
};

export default TitleRow;
